export const saveToLocalStorage = (docId, data) => {
    try {
        const localData = {
            data: data,
            lastUpdateTime: new Date().toISOString()
        };
        // Retrieve existing data from localStorage or initialize with an empty object
        const existingData = JSON.parse(localStorage.getItem('offlineSheets')) || {};
        // Replace or add the sheet data for the given docId
        existingData[docId] = localData;
        // Save updated data back to localStorage
        localStorage.setItem('offlineSheets', JSON.stringify(existingData));
    } catch (error) {
        console.error('Error saving to localStorage:', error);
    }
};

export const updateOrAppendSheet = (sheetData, allSheets = []) => {
  const name = sheetData?.name?.trim?.().toLowerCase?.();
  const i = allSheets.findIndex(s => s?.name?.trim?.().toLowerCase?.() === name);
  if (i >= 0) allSheets[i] = sheetData;
  else allSheets.push(sheetData);
  return [...allSheets];
};

export const removeOfflineData = (id) => {
    const offlineData = JSON.parse(localStorage.getItem('offlineSheets') || '{}');
    delete offlineData[id];
    localStorage.setItem('offlineSheets', JSON.stringify(offlineData));
};